import React from 'react';
import { Chip, Skeleton, Stack } from '@mui/material';
import {
  Card,
  ListItemCardTitle,
  ListItemCardSubtitle,
  ContextMenuComplete,
} from '@marageti/z4-lib';
import { ContextMenuItemType, DestinationItemProps } from './types';

const DestinationItem = ({ destination, onClickEdit }: DestinationItemProps) => {
  const menuItems: ContextMenuItemType[] = [
    { label: 'Edit', action: onClickEdit },
  ];

  const countriesLabel = destination.countries.length > 0
    ? destination.countries.join(', ')
    : 'No countries assigned';

  return (
    <Card>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack alignItems="space-between" minHeight="45px">
          {destination.name ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <ListItemCardTitle>{destination.name}</ListItemCardTitle>
              {!destination.served && (
                <Chip label="Inactive" size="small" color="default" />
              )}
            </Stack>
          ) : (
            <Skeleton variant="text" width="100%" />
          )}
          <ListItemCardSubtitle>{countriesLabel}</ListItemCardSubtitle>
        </Stack>
        <ContextMenuComplete
          id={`destination-card-context-menu-${destination.id}`}
          items={menuItems}
        />
      </Stack>
    </Card>
  );
};

export default DestinationItem;
